export const HUBSPOT_PORTAL_ID = "6072528";
export const HUBSPOT_REGION = "na1";

export const HUBSPOT_FORMS = {
  contact: "5b74772b-677e-416c-abb4-0a64d8806a88",
  footer: "e4920e4a-e4d0-406d-82f7-4bc55e2c415a",
  freeStudyOrganicHeader: "af24be99-d5b4-46a0-96e0-c65b59cadc55",
  freeStudyOrganicFooter: "34e26b4e-64c4-4153-95a3-091e3695619b",
  freeStudyPaidHeader: "0991ae9c-06cf-4b45-81fd-148940256047",
  freeStudyPaidFooter: "638bb8df-dfe1-46b7-b02b-a61719d69752",
  freeStudyLandingOneHeader: "017c7656-94af-4b97-aa74-8c6151e56074",
  freeStudyLandingOneFooter: "3c4acb28-2413-4958-82d6-60fe6933d708",
  freeStudyBusinessHeader: "b8d050a0-f0ed-4436-a783-20a2e48bd5d0",
  freeStudyBusinessFooter: "a8d39c48-b53a-49c7-b5be-6100e4ffec4e",
  industrial: "21f1124a-5f04-440e-96e8-892b4be4ecbe",
  blog: "70e0c613-aa18-4b47-bd42-5c8e08e4c39d",
  ebookVerdadesMentiras: "22475c59-ffaa-4e1e-b5e8-d9cb6846016e",
  ebookPasoAPaso: "d517e92c-0d5d-4a3f-a735-a4f134185252",
  ebookPpaEmpresas: "a937dca0-7da3-4fc9-ab0d-e98ec02bfa0e",
  ebookOportunidadEmpresas: "fc9d2095-384d-4673-bb90-ec990d5a71aa",
  ebookAyudas: "00065d45-7ffd-444a-b989-93b931fce789",
  freeStudyMicrosoftHeader: "6f21613c-0d08-4719-a14c-7e99cce8dcf1",
  freeStudyMicrosoftFooter: "564bc40d-9d30-46a6-8286-76b503078f64",
  freeStudyMetaHeader: "2640ebc6-9732-4d01-9cef-89e80c75bfe0",
  freeStudyMetaFooter: "2d0bed0a-04a1-4e4f-ac50-06464042ce8f",
};
